export default __webpack_public_path__ + "static/media/premios.d8566ce1.png";